import { useState, useEffect } from 'react';
import axios from 'axios';

const SITE_KEY = "6Ldi2QMtAAAAALNKTtZSN9uGhWU1PFLr9rMc0RXl";

const ContactNow = () => {
    const [formdata, setData] = useState({
        firstName: "",
        lastname: "",
        email: "",
        phone: "",
        requirement: "",
        budget: "",
        message: "",
    });

    const [statusMessage, setStatusMessage] = useState("");
    const [captchaReady, setCaptchaReady] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const script = document.createElement("script");

        script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
        script.async = true;
        script.defer = true;

        script.onload = () => {
            setCaptchaReady(true);
            console.log("reCAPTCHA Loaded");
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleEvent = async (e) => {
        e.preventDefault();

        if (!captchaReady || !window.grecaptcha) {
            setStatusMessage("Captcha not ready. Please refresh and try again.");
            return;
        }

        setLoading(true);
        setStatusMessage("");

        try {
            const token = await window.grecaptcha.execute(
                SITE_KEY,
                { action: "contact_form" }
            );

            console.log("reCAPTCHA Token:", token);

            const response = await axios.post(
                "https://akcoda.in/email/email.php",
                {
                    ...formdata,
                    recaptcha_token: token,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log(response.data);

            setStatusMessage("Message sent successfully!");

            setData({
                firstName: "",
                lastname: "",
                email: "",
                phone: "",
                requirement: "",
                budget: "",
                message: "",
            });

        } catch (error) {
            console.error(error);

            setStatusMessage(
                error?.response?.data?.message ||
                "Something went wrong. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="container-fluid p-0"
            style={{
                background:
                    "linear-gradient(to right, #3e13c0ff , #426fecff)",
                marginTop: "-150px",
            }}
        >
            <div
                className="container servicesContent"
                style={{ padding: "50px" }}
            >
                <p style={{ color: "#ffffff" }}>Contact</p>

                <h3
                    style={{
                        color: "#ffffff",
                        fontWeight: "500",
                        fontFamily: "Bungee, sans-serif",
                    }}
                >
                    We Are Just One Click Away?
                </h3>

                <form className="mt-4" onSubmit={handleEvent}>
                    <div className="mb-3 text-secondary">
                        <div className="row justify-content-center align-items-center g-2">

                            <div className="col-md-6 mb-3">
                                <label
                                    className="form-label"
                                    style={{ color: "#ffffff" }}
                                >
                                    First Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="firstName"
                                    value={formdata.firstName}
                                    onChange={handleChange}
                                    placeholder="John"
                                    required
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label
                                    className="form-label"
                                    style={{ color: "#ffffff" }}
                                >
                                    Last Name
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="lastname"
                                    value={formdata.lastname}
                                    onChange={handleChange}
                                    placeholder="Doe"
                                    required
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label
                                    className="form-label"
                                    style={{ color: "#ffffff" }}
                                >
                                    Email Address
                                </label>

                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={formdata.email}
                                    onChange={handleChange}
                                    placeholder="name@example.com"
                                    required
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label
                                    className="form-label"
                                    style={{ color: "#ffffff" }}
                                >
                                    Phone Number
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    value={formdata.phone}
                                    onChange={handleChange}
                                    placeholder="+91-9876543210"
                                    required
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label
                                    className="form-label"
                                    style={{ color: "#ffffff" }}
                                >
                                    Requirement
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="requirement"
                                    value={formdata.requirement}
                                    onChange={handleChange}
                                    placeholder="Website Development"
                                    required
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label
                                    className="form-label"
                                    style={{ color: "#ffffff" }}
                                >
                                    Budget
                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    name="budget"
                                    value={formdata.budget}
                                    onChange={handleChange}
                                    placeholder="99,999"
                                    required
                                />
                            </div>

                            <div className="col-12 mb-3">
                                <label
                                    className="form-label"
                                    style={{ color: "#ffffff" }}
                                >
                                    Message
                                </label>

                                <textarea
                                    className="form-control"
                                    name="message"
                                    rows="5"
                                    value={formdata.message}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="btn"
                                    disabled={loading}
                                    style={{
                                        color: "#3e13c0ff",
                                        backgroundColor: "#ffffff",
                                        fontWeight: "500",
                                        fontFamily: "Bungee, sans-serif",
                                    }}
                                >
                                    {loading ? "Sending..." : "Submit"}
                                </button>
                            </div>
                        </div>

                        {statusMessage && (
                            <p
                                className="mt-3"
                                style={{ color: "#ffffff" }}
                            >
                                {statusMessage}
                            </p>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContactNow;